import {absCenter, colors} from '@xpertdox_js/xdstyle';

export default {
  tabWidgetContainer: {
    float: 'right',
    marginTop: '.4rem'
  },
  btns: {
    verticalAlign: 'top',
    marginRight: '.4rem',
    background: colors.lightBlue
  },
  saveBtn: {
    background: colors.xdHighlight,
    borderRadius: '20rem',
    marginTop: '.3rem',
  },
  loaderStyles: {
    container: {
      height: '100vh',
      position: 'relative',
      width: '100%',
      marginTop: '-4.5rem',
    },
    content: {
      ...absCenter,
    }
  }

}
